/**
 * Typed client for GET /me. Mirrors the shape the `me` Lambda returns.
 *
 * `entitlements` is intentionally `Record<string, unknown>` because MVP 1
 * returns an empty object; MVP 6.5 will widen this into the real entitlements
 * union without changing this wrapper's surface.
 */

import { apiFetch } from './client';

export interface Me {
  uid: string;
  email: string;
  name: string;
  role: string;
  tenantId: string;
  entitlements: Record<string, unknown>;
  membership?: { tenantId: string; role: string } | null;
}

export function getMe(): Promise<Me> {
  return apiFetch<Me>('/me');
}
